"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var react_1 = __importDefault(require("react"));
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var classnames_1 = __importDefault(require("classnames"));
var es_toolkit_1 = require("es-toolkit");
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var QuoteCurrencyFormatter_1 = __importDefault(require("Utils/QuoteCurrencyFormatter"));
var inversify_react_1 = require("inversify-react");
var Discount_service_1 = __importDefault(require("@CommonFrontendBackend/Discount/Discount.service"));
var QuoteComponents_1 = require("./QuoteComponents");
var ItemQuantity_1 = require("Public/Widgets/QuoteV2/ItemQuantity");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var MaybeWrap_1 = __importDefault(require("Utils/MaybeWrap"));
var friendlyFilters_1 = require("./friendlyFilters");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var mobx_1 = require("mobx");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var c = (0, BemBuilder_1.default)("section");
var TableItem = (function (_super) {
    __extends(TableItem, _super);
    function TableItem() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.productFilterWrapperWidth = 0;
        return _this;
    }
    TableItem.prototype.renderTotal = function () {
        var _a;
        var item = this.props.item;
        if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
            var preTaxTotal = (_a = item.total.preTax) !== null && _a !== void 0 ? _a : 0;
            return (react_1.default.createElement("div", { className: c("price") },
                react_1.default.createElement("span", { suppressHydrationWarning: true },
                    react_1.default.createElement("span", { className: c("price-value") }, this.quoteCurrencyFormatter.formatWithUserDecimalPreference(preTaxTotal)),
                    react_1.default.createElement("span", { className: c("price-recurrence") }, this.renderRecurrence()))));
        }
        if (item instanceof QuoteItemStore_1.QuoteProductItemStore) {
            return (react_1.default.createElement("div", { className: c("price") },
                react_1.default.createElement("span", { className: c("price-value") }, "line.total")));
        }
        return null;
    };
    Object.defineProperty(TableItem.prototype, "discountDetailText", {
        get: function () {
            var item = this.props.item;
            if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
                var discountType = void 0;
                if (item.discount.isSavedType() && item.discount.id) {
                    var savedDiscount = this.discountService.findDiscountById(item.discount.id);
                    discountType = savedDiscount.type;
                }
                else {
                    discountType = item.discount.type;
                }
                if (!(0, es_toolkit_1.isNil)(this.discountUnits) && discountType) {
                    var offLabel = this.quoteViewStore.getLabel(Types_1.QuoteLabel.PercentageOff);
                    if (discountType === Types_1.DiscountType.Percent) {
                        return " ".concat(this.discountUnits, "% ").concat(offLabel);
                    }
                    else {
                        return " ".concat(this.quoteCurrencyFormatter.formatWithUserDecimalPreference(this.discountUnits), " ").concat(offLabel);
                    }
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TableItem.prototype, "discountUnits", {
        get: function () {
            var item = this.props.item;
            if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
                if (item.discount.isSavedType() && item.discount.id) {
                    var savedDiscount = this.discountService.findDiscountById(item.discount.id);
                    return savedDiscount.amount;
                }
                else {
                    return item.discount.units;
                }
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    TableItem.prototype.renderDiscount = function () {
        var item = this.props.item;
        if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
            if (item.discount.enabled && !(0, es_toolkit_1.isNil)(this.discountUnits) && this.discountUnits !== 0) {
                return (react_1.default.createElement("div", { className: c("discount-info") },
                    react_1.default.createElement("span", { className: "before-discount-total", "aria-label": "Price before discount" }, this.quoteCurrencyFormatter.formatWithUserDecimalPreference(item.total.preDiscount)),
                    react_1.default.createElement("span", { className: "discount-value" }, this.discountDetailText)));
            }
        }
        return null;
    };
    TableItem.prototype.renderRecurrence = function () {
        var item = this.props.item;
        if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
            if ((0, Types_1.isRecurringSchedule)(item.billingSchedule)) {
                var perLabel = this.quoteViewStore.getLabel((0, Recurrence_1.mapRecurringFrequencyToPerLabel)(item.billingSchedule.frequency));
                return " / ".concat(perLabel);
            }
        }
        return "";
    };
    TableItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, item = _a.item, section = _a.section;
        var fade = this.quoteViewStore.hideMode === QuoteViewStore_1.QuoteHideMode.Fade;
        var maybeWrapWithQuoteProductContext = function (children) {
            return item instanceof QuoteItemStore_1.QuoteProductItemStore && !!_this.quoteComponents.QuoteProductContext ? (react_1.default.createElement(_this.quoteComponents.QuoteProductContext, { token: item.token }, children)) : (children);
        };
        return maybeWrapWithQuoteProductContext(react_1.default.createElement(this.quoteComponents.DragDropHandler, { section: section, item: item, direction: QuoteComponents_1.DragDropHandlerDirection.Vertical }, function (_a) {
            var dragHandlers = _a.dragHandlers, indicatorPosition = _a.indicatorPosition, isDraggingProductListToken = _a.isDraggingProductListToken;
            return (react_1.default.createElement(mobx_react_1.Observer, null, function () {
                var _a, _b, _c, _d, _e, _f;
                return (react_1.default.createElement("tr", __assign({ "data-qwilr-component": "quote-table-row", "data-qwilr-component-id": item.id, className: (0, classnames_1.default)(c("row"), (_a = {},
                        _a["".concat(c("row", "unselected"))] = (0, QuoteItemStore_1.supportsInteractivePricing)(item) && item.isOptional && !item.isOptionalSelected,
                        _a[c("row", "product-item")] = item instanceof QuoteItemStore_1.QuoteProductItemStore,
                        _a[c("drop-indicator")] = !!indicatorPosition,
                        _a[c("drop-indicator", indicatorPosition)] = !!indicatorPosition,
                        _a[c("drop-indicator", "is-dragging")] = isDraggingProductListToken,
                        _a)) }, dragHandlers),
                    (section.showItemDescription || fade) && (react_1.default.createElement("td", { "data-qwilr-component": "line-item-description-cell", className: (0, classnames_1.default)(c("cell"), c("description"), {}) },
                        _this.quoteComponents.ItemAddMenu && (react_1.default.createElement(_this.quoteComponents.ItemAddMenu, { section: section, item: item })),
                        react_1.default.createElement("div", { className: (0, classnames_1.default)(c("description-content-wrapper"), (_b = {},
                                _b["".concat(c("cell", "fade"))] = fade && !section.showItemDescription,
                                _b)) },
                            item instanceof QuoteItemStore_1.QuoteProductItemStore && (react_1.default.createElement(react_resize_detector_1.default, { handleWidth: true, handleHeight: false, onResize: (0, mobx_1.action)(function (width) {
                                    _this.productFilterWrapperWidth = width !== null && width !== void 0 ? width : 0;
                                }) },
                                react_1.default.createElement("div", { className: c("product-filter-wrapper-container") }, !(0, es_toolkit_1.isNil)(_this.productFilterWrapperWidth) && (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("product-filter-wrapper"), "qwilr-font"), style: { maxWidth: "".concat(_this.productFilterWrapperWidth, "px") } },
                                    react_1.default.createElement(MaybeWrap_1.default, { wrapper: function (content) {
                                            return _this.quoteComponents.QuoteProductFilter ? (react_1.default.createElement(_this.quoteComponents.QuoteProductFilter, { item: item, alignment: kaleidoscope_3.PopoverAlignment.Start }, content)) : undefined;
                                        } },
                                        react_1.default.createElement(icons_1.Tokens, { size: icons_1.IconSize.Small }),
                                        react_1.default.createElement(kaleidoscope_2.TruncatedText, { className: c("product-filter-label") }, (0, friendlyFilters_1.stringifyFilter)(item)))))))),
                            react_1.default.createElement("div", { className: (0, classnames_1.default)(c("description-content")) },
                                (0, QuoteItemStore_1.supportsInteractivePricing)(item) && item.isOptional && (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("checkbox"), (_c = {},
                                        _c[c("checkbox", "single-select")] = section.itemSingleSelect,
                                        _c)) },
                                    react_1.default.createElement(kaleidoscope_1.Checkbox, { labelHidden: true, role: section.itemSingleSelect ? "radio" : undefined, id: "line-item-".concat(item.id, "-selected"), label: "Select line item", size: "m", checked: item.isOptionalSelected, disabled: !_this.quoteViewStore.isInteractive, onChange: function () {
                                            section.toggleItemSelection(item);
                                        } }))),
                                react_1.default.createElement(_this.quoteComponents.TableItemDescription, { "data-qwilr-component": "line-item-description", content: item.description })),
                            _this.quoteComponents.DiscountNotice && react_1.default.createElement(_this.quoteComponents.DiscountNotice, { item: item })))),
                    (section.showItemRate || fade) && (react_1.default.createElement("td", { className: (0, classnames_1.default)(c("cell"), (_d = {},
                            _d["".concat(c("cell", "fade"))] = fade && !section.showItemRate,
                            _d)) },
                        react_1.default.createElement(_this.quoteComponents.ItemRate, { item: item }))),
                    (section.showItemQuantity || fade) && (react_1.default.createElement("td", { className: (0, classnames_1.default)(c("cell"), (_e = {},
                            _e["".concat(c("cell", "fade"))] = fade && !section.showItemQuantity,
                            _e)) },
                        react_1.default.createElement(_this.quoteComponents.ItemQuantity, { "data-qwilr-component": "table-item-quantity-input", section: section, item: item, width: ItemQuantity_1.ItemQuantityWidth.Fixed }))),
                    (section.showItemPrice || fade) && (react_1.default.createElement("td", { className: (0, classnames_1.default)(c("cell"), {}) },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)(c("price-wrapper"), (_f = {},
                                _f["".concat(c("cell", "fade"))] = fade && !section.showItemPrice,
                                _f)) },
                            _this.renderTotal(),
                            _this.renderDiscount()),
                        _this.quoteComponents.ItemMenu && react_1.default.createElement(_this.quoteComponents.ItemMenu, { section: section, item: item })))));
            }));
        }));
    };
    var _a, _b, _c, _d;
    __decorate([
        (0, inversify_react_1.resolve)("quoteCurrencyFormatter"),
        __metadata("design:type", typeof (_a = typeof QuoteCurrencyFormatter_1.default !== "undefined" && QuoteCurrencyFormatter_1.default) === "function" ? _a : Object)
    ], TableItem.prototype, "quoteCurrencyFormatter", void 0);
    __decorate([
        (0, inversify_react_1.resolve)("discountService"),
        __metadata("design:type", typeof (_b = typeof Discount_service_1.default !== "undefined" && Discount_service_1.default) === "function" ? _b : Object)
    ], TableItem.prototype, "discountService", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_c = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _c : Object)
    ], TableItem.prototype, "quoteViewStore", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteComponents_1.QuoteComponents.$),
        __metadata("design:type", typeof (_d = typeof QuoteComponents_1.QuoteComponents !== "undefined" && QuoteComponents_1.QuoteComponents) === "function" ? _d : Object)
    ], TableItem.prototype, "quoteComponents", void 0);
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Object)
    ], TableItem.prototype, "productFilterWrapperWidth", void 0);
    TableItem = __decorate([
        mobx_react_1.observer
    ], TableItem);
    return TableItem;
}(react_1.default.Component));
exports.default = TableItem;
